import fetch from "isomorphic-fetch";
import { devAPI } from "../util/urls";
export const getItemsByOrg = async (orgId: string) => {
  const createUrl = (pageNum: number) => {
    const defaultPageSize = 20000;
    return `${devAPI}/items?limit=${defaultPageSize}&page=${pageNum}&detail=3&list=${orgId}`;
  };

  try {
    const items = [];

    const res = await fetch(createUrl(1));
    const parsed = await res.json();

    items.push(...parsed.items);

    if (parsed.pageCount > 1) {
      const promises = [];
      for (let i = 2; i <= parsed.pageCount; i++) {
        const response = fetch(createUrl(i));
        promises.push(response);
      }
      const results = await Promise.all(promises);
      results.map(async (resolved) => {
        const parsedData = await resolved.json();
        items.push(...parsedData.items);
      });
    }

    return items;
  } catch (e) {
    console.error(e);
    return null;
  }
};
